import React from "react";

export default (props) => {

  return (
    <React.Fragment>

      <h1 className="page-title">Guidance</h1>
      <ol>
        <li>Make sure you can use this Homes for Haringey app. If in doubt contact us on <a href="mailto:customerservices@homesforharingey.org">customerservices@homesforharingey.org</a></li>
        <li>Preferably take the supporting pictures beforehand, some devices do not allow taking a picture when filling in the form (you can select an existing picture)</li>
        <li>Go to the starting page and choose the area you wish to have repaired</li>
        <li>Fill in all required details in the form</li>
        <li>Add you pictures by selecting <code>Add Images</code>, here you will either be allowed to take a picture or will only be able to select one from available ones</li>
        <li>Press <code>Submit</code> and check if there are no errors on the page</li>
        <li>If submission was successful you will be presented with a new page showing a submission reference number</li>
        <li>Store the submission reference number for your own records</li>
      </ol>

    </React.Fragment>
  );
};
